import { useEffect } from 'react';
import { hasSession } from '../utils/api';

// Unauthenticated users are sent to the landing site (a different origin).
// react-router's <Navigate> cannot leave the SPA — it treats an absolute URL
// as an in-app path, which falls into the `*` route and loops forever with a
// blank screen — so the redirect must go through window.location instead.
const ProtectedRoute = ({ children }) => {
  const authed = hasSession();

  useEffect(() => {
    if (!authed) {
      window.location.replace((window.ENV && window.ENV.LANDING_URL) || 'https://statusbot.ru');
    }
  }, [authed]);

  return authed ? children : null;
};

export default ProtectedRoute;
